const P = {
  AUTHORIZED: "AUTHORIZED",
  CAPTURED: "CAPTURED",
  CANCELLED: "CANCELLED",
  PENDING: "PENDING",
  FAILED: "FAILED",
  INITIATED: "INITIATED",
  PAID: "PAID"
}, I = "VALIDATED", D = {
  PAID: {
    keys: ["CAPTURED"],
    id: "paid",
    value: "order.payment.paid"
  },
  PENDING: {
    keys: ["INITIATED", "PENDING", "AUTHORIZED"],
    id: "pending",
    value: "order.payment.pending"
  },
  DENIED: {
    keys: ["FAILED", "AUTHORIZED_FAILED", "CAPTURED_FAILED", "REFUND_FAILED", "ABORTED", "INITIATED_FAILED"],
    id: "failed",
    value: "order.payment.denied"
  },
  REFUNDED: { keys: ["REFUNDED", "VOID"], value: "order.payment.refund", id: "refund" },
  AWAITED: { keys: ["AWAITED"], value: "order.payment.awaited", id: "awaited" },
  PARTIAL_CAPTURED: { keys: ["PARTIAL_CAPTURED"], value: "order.payment.partial", id: "partial" },
  CANCELLED: { keys: ["CANCEL", "CANCELLED"], value: "order.payment.cancelled", id: "cancelled" },
  NOT_FOUND: {
    keys: ["NOT_FOUND"],
    id: "notFound",
    value: "order.payment.denied"
  },
  PARTPAID: {
    keys: ["PARTIAL_CAPTURED"],
    id: "partPaid",
    value: "order.payment.partpaid"
  },
  NOTPAID: {
    keys: ["NOTPAID"],
    id: "notPaid",
    value: ""
  }
}, A = {
  PAYMENT_PAID: "PAYMENT_PAID",
  PAYMENT_AWAITED: "PAYMENT_AWAITED",
  PAYMENT_RETRY: "PAYMENT_RETRY",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  PAYMENT_REFUNDED: "PAYMENT_REFUNDED",
  PAYMENT_CANCELLED: "PAYMENT_CANCELLED",
  PAID: "PAID",
  PARTPAID: "PAYMENT_PARTPAID",
  NOTPAID: "NOTPAID"
}, E = {
  PAID: {
    keys: [A.PAID],
    id: "paid",
    value: "order.payment.paid"
  },
  NOTPAID: {
    keys: [A.NOTPAID],
    id: "notpaid",
    value: "order.payment.notpaid"
  },
  PARTPAID: {
    keys: [A.PARTPAID],
    id: "partpaid",
    value: "order.payment.partpaid"
  }
}, e = {
  [A.PAYMENT_PAID]: D.PAID.value,
  [A.PAYMENT_AWAITED]: D.AWAITED.value,
  [A.PAYMENT_RETRY]: D.DENIED.value,
  [A.PAYMENT_PENDING]: D.PENDING.value,
  [A.PAYMENT_REFUNDED]: D.REFUNDED.value,
  [A.PAYMENT_CANCELLED]: D.CANCELLED.value,
  [A.PAID]: E.PAID.value,
  [A.PARTPAID]: E.PARTPAID.value,
  [A.NOTPAID]: E.NOTPAID.value
}, N = "X-Amway-Country", T = {
  PROMOTION: "promotion",
  COUPON: "coupon"
}, a = "POS", d = "REFUND_INITIATED", R = "TH_PAY_LATER_CNB";
export {
  A,
  P as E,
  e as I,
  T as N,
  I as T,
  N as d,
  D as e,
  d as i,
  R as n,
  a as r
};
//# sourceMappingURL=paymentContants-fc6a39d2.mjs.map
